import appConfig from '../../../config/appConfig';

var config = {
  apiUrl: appConfig.apiUrl + 'storagelocations/',
  fastSearchUrl: appConfig.apiUrl + 'storagelocations/fastsearch/'
};

export default config;



// WEBPACK FOOTER //
// ./src/components/storagelocations/config/storagelocationConfig.js